import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/next/Button/Button';
import Icon from 'components/next/Icon/Icon';
import { PartnerDepartmentStatisticsDto } from 'types/dto/contracts-service';
import onDownload from 'callbacks/onDownload';
import * as api from 'api/statistics';

import Card, { cssTitle } from '../Card/Card';
import Chart from './ByDepartmentChart/ByDepartmentChart';
import Table from './ByDepartmentTable/ByDepartmentTable';
import Switch from '../Switch/Switch';
import { transformData, transformDataForChart } from './ByDepartment.model';

interface Props {
  data: PartnerDepartmentStatisticsDto[];
  currency: string;
}

const ByDepartment = ({ data, currency }: Props) => {
  const { t } = useTranslation();
  const [isChart, setIsChart] = useState(false);

  const transformedData = useMemo(() => transformData(data), [data]);
  const transformedDataForChart = useMemo(() => transformDataForChart(transformedData), [transformedData]);
  const hasData = Boolean(transformedData.length);

  const onClickExcel = () => {
    onDownload(() => api.printXlsxPartnerDepartmentStatisticsUsingPost(data), {}, t);
  };

  return (
    <Card
      isChart={isChart}
      hasData={hasData}
      title={
        <>
          <span className={cssTitle}>{t('dashboard_extend.byDepartment.title')}</span>
          {hasData && (
            <Switch
              checked={isChart}
              onChange={() => {
                setIsChart(!isChart);
              }}
            />
          )}
        </>
      }
      extra={
        hasData && (
          <Button onClick={onClickExcel}>
            <Icon type="excel" color="primary" />
            Excel
          </Button>
        )
      }
    >
      {isChart ? (
        <Chart data={transformedDataForChart} currency={currency} />
      ) : (
        <Table data={transformedData} currency={currency} />
      )}
    </Card>
  );
};

export default ByDepartment;
